import React, { useMemo } from 'react'
import Link from 'next/link'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { getZT } from 'lib/zt-util'

interface IColor {
  color: string
  key: string
  color_name: string
  car_ids?: number[]
}
export interface IList {
  text: string
  key: string
  filter: {
    color: IColor[]
  }
}
interface IAside {
  list: IList[]
  category: string
  color: string
  categoryImages: {
    [key: string]: number
  }
  seriesId: string
  carId: number
  price?: string
}

const Aside: React.FC<IAside> = (props) => {
  const { carId, seriesId, category, color, list, price, categoryImages } =
    props
  if (!list || !list.length) return null
  const index = useMemo(() => {
    return list.findIndex((item) => item.key === category)
  }, [category, list])
  return (
    <aside>
      {list.map(({ text, key }, index) => {
        return (
          <Link
            href={`/auto/images/detail`}
            as={`/series-${seriesId}/images/${key}-${carId || 'x'}-x-x`}
            key={text}
          >
            <a style={{ color: 'inherit' }}>
              <div
                className={classnames(`hover:tw-text-current`, {
                  'space-filter': true,
                  active: key === category,
                  disabled: categoryImages[key] === 0,
                  'tw-mt-4': index,
                })}
                onClick={() => {
                  sendTeaCommEvent('click_series_picture_detail_category', {
                    car_series_id: seriesId,
                    car_style_id: carId,
                    sub_tab: key,
                    body_color: color,
                  })
                }}
              >
                <span>{text}</span>
                <span>{categoryImages[key] || 0}张图</span>
              </div>
            </a>
          </Link>
        )
      })}
      {list[index]?.filter && (
        <div className="color-picker">
          <span>颜色选择</span>
          <span>
            {list[index].filter.color.map((item, index) => {
              const carIds = item.car_ids || []
              const colors = item.key.split('_').filter((color) => color)
              const disabledColor = carId && carIds.indexOf(carId) <= -1

              let background
              if (colors.length > 1) {
                background = `linear-gradient(to right, ${colors
                  .map((color, index) => {
                    return `#${color} 50%${
                      index !== colors.length - 1 ? ', ' : ''
                    }`
                  })
                  .join('')})`
              } else if (colors.length === 1) {
                background = `#${colors[0]}`
              } else {
                background = `#ffffff`
              }
              return (
                <Link
                  href={`/auto/images/detail`}
                  as={`/series-${seriesId}/images/${category}-${carId || 'x'}-${
                    item.key || 'x'
                  }-x`}
                  key={item.key}
                >
                  <a>
                    <i
                      key={item.key}
                      style={{ background }}
                      className={classnames({
                        checked: color === item.key,
                        'icon-oval-ic': index === 0,
                        'disabled-color': disabledColor,
                      })}
                      title={`${disabledColor ? '暂无 ' : ''}${
                        item.color_name
                      }`}
                      onClick={(eve) => {
                        if (disabledColor) {
                          eve.stopPropagation()
                          eve.preventDefault()
                          return
                        }
                        sendTeaCommEvent('click_series_picture_detail_color', {
                          car_series_id: seriesId,
                          car_style_id: carId,
                          sub_tab: category,
                          body_color: item.key,
                        })
                      }}
                    />
                  </a>
                </Link>
              )
            })}
          </span>
        </div>
      )}
      <Link
        href={`/dealer?seriesId=${seriesId}&zt=${getZT('pc_series_pic')}`}
        as={`/dealer/${seriesId}?zt=${getZT('pc_series_pic')}`}
      >
        <a target="_blank">
          <div
            className="card"
            onClick={() => {
              sendTeaCommEvent('click_series_picture_detail_inquiry', {
                car_series_id: seriesId,
                car_style_id: carId,
                sub_tab: category,
                body_color: color,
              })
            }}
          >
            <span>{price}</span>
            <span>询底价</span>
          </div>
        </a>
      </Link>
      <style jsx>
        {`
          aside {
            position: relative;
            width: 118px;
            height: 715px;
            font-family: PingFangSC;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            color: rgba(255, 255, 255, 0.4);
          }
          div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 118px;
            height: 80px;
            box-sizing: border-box;
            background-color: rgba(255, 255, 255, 0.2);
          }
          .space-filter {
            cursor: pointer;
            user-select: none;
          }
          span:first-child {
            display: block;
            font-size: 20px;
          }
          .active {
            border-top: 6px solid #ffe100;
            color: #000;
            background-color: #fff;
          }
          .disabled {
            pointer-events: none;
            cursor: default;
          }
          .checked {
            border: solid 2px #ffe100;
          }
          .color-picker {
            display: block;
            height: auto;
            text-align: center;
            background-color: rgba(0, 0, 0, 0);
          }
          .color-picker span:first-child {
            margin: 16px 0;
            height: 22px;
            font-size: 16px;
            color: #ffffff;
          }
          .color-picker span:last-child {
            font-size: 0;
          }
          i {
            display: inline-block;
            margin: 0 4px 12px 4px;
            width: 28px;
            height: 28px;
            line-height: 25px;
            font-size: 0;
            border: solid 1px #e6e6e6;
            cursor: pointer;
          }
          .icon-oval-ic {
            font-size: 16px;
            color: #b5b5b5;
            margin-top: 0px;
            vertical-align: text-bottom;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          .disabled-color {
            opacity: 0.2;
            cursor: auto;
          }
          .card {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            height: auto;
            background-color: transparent;
          }
          .card span {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .card span:first-child {
            height: 36px;
            font-size: 14px;
            color: #ffffff;
            background-color: rgba(255, 255, 255, 0.2);
          }
          .card span:last-child {
            height: 52px;
            font-size: 20px;
            font-weight: 500;
            text-align: center;
            color: #1a1a1a;
            background-color: #ffe100;
          }
        `}
      </style>
    </aside>
  )
}

export default Aside
